import React, { useState } from 'react'

// bootstrap
import { Tabs, Tab } from 'react-bootstrap'

// components
import VariationsMain from '../../Variations/VariationsMain'
import VariationsOptions from '../../Variations/VariationsOptions'

export default function VariationsTab(props) {
    // props
    const {
        formik,

        productCombinations,
        setProductCombinations,
        productCombinationsImages,
        variantMainFields,

        disabledVariantList,
        setDisabledVariantList,

        handleVariantPageShow
    } = props

    // states
    const [activeTab, setActiveTab] = useState("options")

    return (
        <React.Fragment>
            <Tabs
                id="variations-tab"
                defaultActiveKey={activeTab}
                onSelect={(tab) => setActiveTab(tab)}
                className="st-tabs-bootstrap px-2">
                <Tab eventKey="options" title="Options">
                    <VariationsOptions
                        variantMainFields={variantMainFields}

                        handleVariantPageShow={handleVariantPageShow}
                    />
                </Tab>

                <Tab eventKey="variations" title="Variations">
                    <VariationsMain
                        formik={formik}

                        productCombinations={productCombinations}
                        setProductCombinations={setProductCombinations}
                        productCombinationsImages={productCombinationsImages}

                        disabledVariantList={disabledVariantList}
                        setDisabledVariantList={setDisabledVariantList}
                    />
                </Tab>
            </Tabs>
        </React.Fragment>
    )
}
